import React from "react";
import { Info, X, ArrowRight } from "lucide-react";

export const CHANGED_QUESTIONS = [
  { id: "ind_fiscal_14", label: "Restricted fund issues" },
  { id: "ind_mission_13", label: "Mission noncompliance or misalignment" },
  { id: "ind_student_perf_11", label: "Subgroup gap" },
];

export const ScoringUpdateBanner = ({ onDismiss, onJump }) => (
  <div role="region" aria-label="Scoring update" className="mb-4 flex items-start gap-3 rounded-lg border border-[#bfe3ee] bg-[#eef6f9] px-4 py-3 text-[14px] text-[#1f2937]" data-testid="scoring-update-banner">
    <Info className="mt-0.5 h-4 w-4 shrink-0 text-[#007a9e]" aria-hidden="true" />
    <div className="min-w-0 flex-1">
      <p className="font-semibold">What changed in scoring</p>
      <p className="mt-1 leading-relaxed">
        This diagnostic uses updated scoring for three questions: answering <b>No</b> to <i>Restricted fund issues</i> or to
        <i> Mission-related noncompliance or misalignment</i> now earns full credit, and a <b>smaller</b> <i>Subgroup gap</i> now scores higher.
        Your earlier diagnostic results are unchanged.
      </p>
      {onJump && (
        <div className="mt-2 flex flex-wrap gap-2">
          {CHANGED_QUESTIONS.map((q) => (
            <button key={q.id} type="button" onClick={() => onJump(q.id)} className="inline-flex min-h-[36px] items-center gap-1 rounded-full border border-[#007a9e] bg-white px-3 text-[13px] font-semibold text-[#005f7b] hover:bg-[#e0f2f7]" data-testid={`scoring-update-jump-${q.id}`}>
              {q.label} <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          ))}
        </div>
      )}
    </div>
    <button type="button" onClick={onDismiss} aria-label="Dismiss scoring update" className="-m-1 rounded p-2 text-[#4b5563] hover:bg-white/70" data-testid="scoring-update-banner-dismiss">
      <X className="h-4 w-4" />
    </button>
  </div>
);
